<template>
  <BbBtn class="replace_button" size="small" type="secondary">
    <BbIcon size="small" name="medialibrary" />
    <TextBody i18n-key="common.replace" />
  </BbBtn>
</template>

<script>
import TextBody from '~/components/common/TextBody.vue';

export default {
  components: { TextBody },
};
</script>

<style lang="scss" scoped>
.replace_button {
  pointer-events: auto;
  display: inline-flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  border: 1px solid #cecdcc;
  background: $bb-neutral-0;
  min-width: 100px !important;
  flex: auto;

  :deep(.v-btn__content) {
    gap: $bb-spacing-1;
  }
}
</style>
